import { render } from "./FooterBar.vue?vue&type=template&id=f1527430&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=f1527430&scoped=true&lang=scss"

import exportComponent from "/Users/Sacha/Projects/ftminstallatietechniek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1527430"]])

export default __exports__